export default "__VITE_PUBLIC_ASSET__cf3c9e2e__"